import { BeanRenderLike } from './beanRenderLike.ts';

export class BeanRenderBase extends BeanRenderLike {
  public render() {}
}
